import { ReactNode } from 'react';
import { CatButton, CatHeading } from 'components/blocks-components';
import { useDealerLocatorModal } from 'components/dealer-locator/dealer-locator-modal-context';
import { useLoginUrl } from 'hooks/use-login-url';
import styles from './register-signin-button-toast.module.scss';
import cx from 'classnames';
import {
  ButtonSize,
  ButtonVariant
} from '@blocks-web-components/components/button/button.model';

type RegisterSignInButtonToastProps = {
  signInText: string;
  registerText: string;
  guestSaveText: string | ReactNode;
  containerClassname?: string;
  signInButtonVariant?: ButtonVariant;
  registerButtonVariant?: ButtonVariant;
  buttonSize?: ButtonSize;
  redirectionUrl?: string;
};
export const RegisterSignInButtonToast = ({
  guestSaveText,
  registerText,
  signInText,
  containerClassname,
  signInButtonVariant,
  registerButtonVariant,
  buttonSize = 'sm',
  redirectionUrl = ''
}: RegisterSignInButtonToastProps) => {
  const dealerLocatorModal = useDealerLocatorModal();
  const isFlexLayout = containerClassname?.includes('d-md-flex');
  const loginUrl = useLoginUrl(redirectionUrl);

  return (
    <div {...(containerClassname && { className: cx(containerClassname) })}>
      <CatHeading
        variant="body-sm"
        className={cx('me-2', {
          [styles['register-signin-button-toast__text']]: isFlexLayout
        })}
      >
        {guestSaveText}
      </CatHeading>
      <div
        className={cx({
          ['mt-2 ms-n3']: !isFlexLayout,
          [styles['register-signin-button-toast__buttons']]: isFlexLayout
        })}
      >
        <CatButton
          {...(signInButtonVariant && { variant: signInButtonVariant })}
          {...(isFlexLayout && { className: 'me-2' })}
          size={buttonSize}
          href={loginUrl}
          data-testid="sign-in-button"
        >
          <span className="text-capitalize">{signInText.toLowerCase()}</span>
        </CatButton>
        <CatButton
          {...(registerButtonVariant && { variant: registerButtonVariant })}
          size={buttonSize}
          onClick={() => dealerLocatorModal.modalControl.open()}
          data-testid="register-button"
        >
          <span className="text-capitalize">{registerText}</span>
        </CatButton>
      </div>
    </div>
  );
};
